import { render, staticRenderFns } from "./wxNoticeSetting.vue?vue&type=template&id=1608fef9&scoped=true"
import script from "./wxNoticeSetting.vue?vue&type=script&lang=js"
export * from "./wxNoticeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608fef9",
  null
  
)

export default component.exports